export default function initHeaderParallax() {
  //parallax
  let images = document.querySelectorAll('.hero-image .background');

  Array.from(images).forEach(image => {
    image.dataset.top = +parseInt(getComputedStyle(image).top, 10);
  });

  window.addEventListener('scroll', () => {
    let scrolled = window.pageYOffset;

    Array.from(images).forEach(image => {
      image.style.top = parseInt(image.dataset.top) + (scrolled * .5) + 'px';
    });
  });
}
